/*** IMPORTS FROM imports-loader ***/
var define = false;

require('../modules/web.dom-collections.iterator');
require('../modules/es.string.iterator');
var getIterator = require('../internals/get-iterator');

module.exports = getIterator;

